import { render, staticRenderFns } from "./TopBrowsers.vue?vue&type=template&id=482a4aee"
import script from "./TopBrowsers.vue?vue&type=script&lang=js"
export * from "./TopBrowsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports